import React from "react";
import { Link } from "react-router-dom";

const AboutContent = () => {
  return (
    <div className="how__work">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/company/about_us/about_us_1.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>Who We Are</h2>
              <p>
                The Pips is a next-generation trading and investment platform
                designed to simplify the complex world of finance. We offer
                access to global markets; Forex, Crypto, and Stocks, alongside
                comprehensive learning resources and expert mentorship. Our goal
                is to build confident traders through transparency, education,
                and technology that works for you, not against you. We’re not
                just a platform; we’re your trading partner, guiding you
                throughout the way with tools and insights that inspire smarter
                decisions and steady growth. Everything we create is built to
                empower you at every stage of your trading journey.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/register"}
              >
                Register now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
